export const USER_ASSETS_PREFIX = 'user:assets:';
export const ASSETS_STALE_MS = 5 * 60 * 1000;

export function assetsCacheKey(scope = 'all') {
  return `${USER_ASSETS_PREFIX}${scope || 'all'}`;
}

function readEntry(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.data)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function getCachedAssets(scope = 'all', { allowStale = true, now = Date.now() } = {}) {
  const entry = readEntry(assetsCacheKey(scope));
  if (!entry) return null;
  if (!allowStale && now - Number(entry.ts || 0) > ASSETS_STALE_MS) return null;
  return entry.data;
}

export function setCachedAssets(scope, data) {
  if (!Array.isArray(data)) return;
  try {
    sessionStorage.setItem(assetsCacheKey(scope), JSON.stringify({ data, ts: Date.now() }));
  } catch {
    // sessionStorage may be unavailable
  }
}

export function invalidateAssetsCache() {
  try {
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(USER_ASSETS_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // ignore
  }
}
